/* __next_internal_client_entry_do_not_use__ NoSSR auto */ import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import React from "react";
/**
 * Opt out of server side rendering. This component will render its children
 * on the client side only.
 *
 * You can also provide a `serverRenderFallback` prop to render something else on the server.
 */ export var NoSSR = function(param) {
    var children = param.children, serverRenderFallback = param.serverRenderFallback;
    var isSSR = useIsSSR();
    if (isSSR) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: serverRenderFallback
        });
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
};
